// src/store/purchaseModalManagment/reducer.ts

import {
  PurchaseModalState,
  initialState,
  PurchaseModalActionTypes,
  OPEN_PURCHASE_MODAL,
  CLOSE_PURCHASE_MODAL,
} from './types';

const purchaseModalReducer = (
  state: PurchaseModalState = initialState,
  action: PurchaseModalActionTypes
): PurchaseModalState => {
  switch (action.type) {
    case OPEN_PURCHASE_MODAL:
      return { open: true, ...action.payload };

    case CLOSE_PURCHASE_MODAL:
      return initialState;

    default:
      return state;
  }
};

export default purchaseModalReducer;
